import React from 'react'
import DataTable from './datatable'
import {useSOPs, useSelectedSOPs } from '../redux/plan'


  const Filter = () =>{
    const datos = useSOPs()
    const selected =  useSelectedSOPs() 
    
    return (
      <div style={{flexGrow:1}}>
        <DataTable datos={datos} selected={selected} />
      </div>
    )
  }
  
  export default Filter